<template>
  <el-select v-model="obj.modelVal" filterable :multiple="obj.multiple" :placeholder="obj.placeholder "
    style="width:100%" :disabled="obj.disabled" v-el-select-loadmore="loadmore" :filter-method="getSearch"
    @focus="emptyVal()" @change="change">
    <el-option v-for="(item,index) in list" :key="index" :label="item[obj.optionName]" :value="item[obj.optionVal]">
    </el-option>
  </el-select>
</template>

<script>
  import Util from "../Util"
  export default {
    directives: {
      "el-select-loadmore": {
        bind(el, binding) {
          // 获取element-ui定义好的scroll盒子
          const SELECTWRAP_DOM = el.querySelector(
            ".el-select-dropdown .el-select-dropdown__wrap"
          );
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            /**
             * scrollHeight 获取元素内容高度(只读)
             * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
             * clientHeight 读取元素的可见高度(只读)
             * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
             * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
             */
            const condition =
              this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    data() {
      return {
        list: [],
        searchVal: ""
      }
    },
    props: ["obj", "url", "formData", "parameter"],
    watch: {},
    methods: {
      change(e) {
        this.$emit("changeFn", e);
        this.$forceUpdate()
      },
      //    下拉聚焦
      emptyVal() {
        if (!this.obj.modelVal || !this.obj.modelVal.length) {
          this.list = []
          this.formData.page = 1
          this.formData.size = 10
          this.searchVal = ""
          this.getList(this.searchVal);
        }
      },
      //    滚动
      loadmore() {
        this.formData.page++;
        this.getList(this.searchVal);
      },
      //  关键字
      getSearch(val) {
        this.searchVal = val;
        this.list = [];
        this.formData.page = 1
        this.getList(val);
      },
      //   列表
      getList(val) {
        let data = {
          page: this.formData.page,
          size: this.formData.size,
          key: val
        }
        if (this.parameter) {
          for (let i in this.parameter) {
            if (this.parameter[i]) {
              data[i] = this.parameter[i]
            }
          }
        }
        console.log(this.parameter, data)
        this.$http.post(`${Util.searchURL}${this.url}`, data).then(
          res => {
            if (res.data.code === 200) {
              const _res = res.data.data.data; // 请求得到的数据
              this.list = [...this.list, ..._res];
            }
          },
          err => {
            console.log(err);
          }
        );
      },
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/loadSelect.vue